import React from 'react'
import './selector-language-footer-mobile.less'
import { useTranslation } from 'react-i18next'
import eng from '../../assets/flags/eng.png'
import fin from '../../assets/flags/fin.png'
import est from '../../assets/flags/est.png'
import sve from '../../assets/flags/sve.png'
import lat from '../../assets/flags/lat.png'
import rus from '../../assets/flags/rus.png'
import pol from '../../assets/flags/pol.png'

const langs = [
  { img: eng, code: 'en' },
  { img: est, code: 'et' },
  { img: fin, code: 'fi' },
  { img: sve, code: 'sv' },
  { img: lat, code: 'lv' },
  { img: pol, code: 'pl' },
  { img: rus, code: 'ru' },
]

interface Props {
  onClose: () => void
  onExit: () => void
}

const SelectorLanguageFooterMobile: React.FC<Props> = ({ onClose, onExit }) => {
  const { i18n, t } = useTranslation()

  const onSelect = (code: string) => {
    i18n.changeLanguage(code)
    onClose()
  }

  return (
    <div className="selector-language-footer-mobile">
      <div className="flags-container">
        {langs.map((item, index) => (
          !(index % 3) && <div key={item.code} className="flags-row">
            <img
              className="flag"
              src={item.img}
              alt="flag"
              onClick={() => onSelect(item.code)}
            />
            {!!langs[index + 1] && <img
              className="flag"
              src={langs[index + 1].img}
              alt="flag"
              onClick={() => onSelect(langs[index + 1].code)}
            />}
            {!!langs[index + 2] && <img
              className="flag"
              src={langs[index + 2].img}
              alt="flag"
              onClick={() => onSelect(langs[index + 2].code)}
            />}
          </div>
        ))}
      </div>
      <div className="button-container">
        <button className="main-button-mobile exit-button" onClick={onExit}>{t('exit')}</button>
      </div>
    </div>
  )
}

export default SelectorLanguageFooterMobile
